export const X7Type = {
  GenericRelay: 0,
  DigitalInput: 1
};

export const X7TypeText = {
  [X7Type.GenericRelay]: 'Generic',
  [X7Type.DigitalInput]: 'Digital Input'
};
